import { injectReducer } from "store/reducers";
import withAsyncRouteLoading from "UIComponents/AsyncRouteLoadingHoc";

import { GlobalMatch } from "./routes";

export default store => ({
  path: "notificationsmanager",
  component: withAsyncRouteLoading(
    () =>
      Promise.all([
        import(
          /* webpackChunkName: "NotificationsManager" */ "./components/NotificationsManager"
        ),
        import(
          /* webpackChunkName: "notification-settings" */ "./modules/NotificationsManagerModule"
        ),
      ]).then(([importedModule0, importedModule1]) => {
        const component = importedModule0.default;
        const reducer = importedModule1.default;
        injectReducer(store, {
          key: "notificationsmanager",
          reducer,
        });
        return component;
      })
    //.catch(err => {
    //   throw err;
    // })
  ),
  childRoutes: [GlobalMatch(store)],
});
